import { Check } from "lucide-react";
import type { Capability } from "../pages/integrations/IntegrationsPage.utils";
import { capabilityIcons } from "../pages/integrations/IntegrationsPage.utils";

export function CapabilityPills({
  capabilities,
}: {
  capabilities: Capability[];
}) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {capabilities.map((capability) => {
        const Icon = capabilityIcons[capability.key] ?? Check;
        return (
          <span
            key={capability.key}
            className="inline-flex items-center gap-1 rounded-full bg-lumen-50 px-2.5 py-1 text-xs font-medium text-lumen-800 dark:bg-lumen-950/50 dark:text-lumen-200"
          >
            <Icon size={12} /> {capability.label}
          </span>
        );
      })}
    </div>
  );
}
